<template>
  <div>
    <h2>Đăng ký thi thử hàng tuần</h2>

    <p class="text-justify">Kho bài thi đánh giá năng lực tiếng Trung chất lượng hàng đầu cho tất cả các trình độ HSK 1, HSK 2, HSK 3, HSK 4, HSK 5, HSK 6. Tất cả các câu hỏi trong đề thi đều được biên soạn bởi các giáo viên có nhiều năm kinh nghiệm, đề thi được xây dựng dựa trên ma trận đề thi thật.</p>
    
    <b-alert show="10" variant="danger" v-model="showErrors" dismissible>
      <div v-for="(item, index) in error" :key="index">
        <div v-for="(item_err, index_item) in item" :key="index_item">
          <li>{{ item_err }}</li>
        </div>
      </div>
    </b-alert>
    
    <b-form @submit="onSubmit" @reset="onReset" v-if="show" class="auth__form">
      <b-input-group
        id="input-phone"
        label="Họ và tên:"
        label-for="name"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="id-card" />
        </b-input-group-append>
        <b-form-input
          id="name"
          v-model="form.name"
          type="text"
          required
          placeholder="Họ và tên"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-input-group
        id="input-phone"
        label="Số điện thoại:"
        label-for="phone"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="phone" />
        </b-input-group-append>
        <b-form-input
          id="phone"
          v-model="form.phone"
          type="text"
          required
          placeholder="Số điện thoại"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <!-- <b-input-group
        id="input-phone"
        label="Tỉnh/Thành:"
        label-for="location"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="location-arrow" />
        </b-input-group-append>
        <b-form-select
          id="location"
          v-model="form.location"
          :options="provinces"
          required
          class="auth__form__input"
        >
          <template v-slot:first>
            <option value="" disabled>-- Chọn Tỉnh / Thành --</option>
          </template>
        </b-form-select>
      </b-input-group> -->

      <b-input-group
        id="input-email"
        label="Email address:"
        label-for="email"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="envelope" />
        </b-input-group-append>
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          required
          placeholder="Email của bạn"
          autocomplete="off"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-input-group
        id="input-password"
        label="Mật khẩu:"
        label-for="password"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="lock" />
        </b-input-group-append>
        <b-form-input
          id="password"
          v-model="form.password"
          type="password"
          required
          placeholder="Mật khẩu của bạn"
          autocomplete="off"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-input-group
        id="input-password-confirm"
        label="Nhập lại mật khẩu:"
        label-for="password-confirm"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="lock" />
        </b-input-group-append>
        <b-form-input
          id="password-confirm"
          v-model="form.passwordConfirm"
          type="password"
          required
          placeholder="Nhập lại mật khẩu"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-button type="submit" class="auth__form__btn">Đăng ký</b-button>

      <p>Đã có tài khoản? Hãy <router-link :to="{ name: 'auth-login' }">Đăng nhập</router-link></p>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
        passwordConfirm: '',
        name: '',
        phone: '',
        location: ''
      },
      nextUrl: '',
      provinces: ['Hà Nội', 'Hồ Chí Minh', 'An Giang', 'Bà Rịa - Vũng Tàu', 'Bắc Giang', 'Bắc Kạn', 'Bạc Liêu', 'Bắc Ninh', 'Bến Tre', 'Bình Dương', 'Bình Phước', 'Bình Thuận', 'Bình Định', 'Cà Mau', 'Cần Thơ', 'Cao Bằng', 'Gia Lai', 'Hà Giang', 'Hà Nam', 'Hà Tĩnh', 'Hải Dương', 'Hải Phòng', 'Hậu Giang', 'Hoà Bình', 'Hưng Yên', 'Khánh Hòa', 'Kiên Giang', 'Kon Tum', 'Lai Châu', 'Lâm Đồng', 'Lạng Sơn', 'Lào Cai', 'Long An', 'Nam Định', 'Nghệ An', 'Ninh Bình', 'Ninh Thuận', 'Phú Thọ', 'Phú Yên', 'Quảng Bình', 'Quảng Nam', 'Quảng Ngãi', 'Quảng Ninh', 'Quảng Trị', 'Sóc Trăng', 'Sơn La', 'Tây Ninh', 'Thái Bình', 'Thái Nguyên', 'Thanh Hóa', 'Thừa Thiên Huế', 'Tiền Giang', 'Trà Vinh', 'Tuyên Quang', 'Vĩnh Long', 'Vĩnh Phúc', 'Yên Bái', 'Đà Nẵng', 'Đắk Lắk', 'Đắk Nông', 'Điện Biên', 'Đồng Nai', 'Đồng Tháp'],
      show: true,
      showErrors: false
    }
  },
  computed: {
    ...mapState('auth', ['isLoggedIn', 'error'])
  },
  watch: {
    error(value) {
      if(value != null) {
        this.showErrors = true;
      }
    }
  },
  created() {
    this.nextUrl = this.$route.query.nextUrl;
  },
  methods: {
    ...mapActions(`auth`, ['authRegister', 'clearData']),
    onSubmit(evt) {
      evt.preventDefault()
      this.authRegister({...this.form, nextUrl: this.nextUrl})
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.password = ''
      this.form.passwordConfirm = ''
      this.form.phone = ''
      this.form.location = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
    }
  },
  beforeDestroy() {
    this.clearData()
  }
}
</script>